import React from 'react'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import { Column, Row, Text } from 'Components/UI'

import GradientPointGlyph from 'Assets/Svg/gradientPoint.svg'

import { COMPANY_HISTORY_ITEMS } from './constants'
import { ArtsHolder, Content, Line } from './styles'

type Props = PaddingProps

function CompanyHistorySection({ ...rest }: Props) {
  return (
    <SectionWrapper {...rest}>
      <Content flexDirection={['column', 'column', 'column', 'column', 'row']}>
        <Text as="h2" medium title title40>
          Company History
        </Text>

        <Column maxWidth={['unset', 'unset', 'unset', 'unset', '60%']}>
          {COMPANY_HISTORY_ITEMS.map(item => (
            <Row gap={9} key={item.id} minHeight="100px">
              <ArtsHolder>
                {GradientPointGlyph()}

                <Line />
              </ArtsHolder>

              <Column gap={3} py={6}>
                <Text body body20 medium>
                  {item.date}
                </Text>

                <Text body body16 semiLight>
                  {item.caption}
                </Text>
              </Column>
            </Row>
          ))}
        </Column>
      </Content>
    </SectionWrapper>
  )
}

export default CompanyHistorySection
